import type { ReactNode } from "react";
import Modal from "@modalSrc/Modal";
import "./HelpModal.scss";

type HelpModalProps = {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    content?: ReactNode;
    size?: string;
};

export default function HelpModal({ isOpen, onClose, title = "Help", content, size = "md" }: HelpModalProps) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            size={size}
            overlayClassName="helpModalOverlay"
        >
            {content}
        </Modal>
    );
}


